var ELEMENT_NODE = 1;
var getRect = function (node) {
    var offsetParent = node.offsetParent;
    var height = node.offsetHeight;
    var width = node.offsetWidth;
    var left = node.offsetLeft;
    var top = node.offsetTop;
    while (offsetParent && offsetParent.nodeType === ELEMENT_NODE) {
        left += offsetParent.offsetLeft - offsetParent.scrollLeft;
        top += offsetParent.offsetTop - offsetParent.scrollTop;
        offsetParent = offsetParent.offsetParent;
    }
    return {
        height: height,
        left: left,
        top: top,
        width: width,
    };
};
var measureLayout = function (node) {
    var relativeNode = node && node.parentElement;
    if (node && relativeNode) {
        var relativeRect = getRect(relativeNode);
        var _a = getRect(node), height = _a.height, left = _a.left, top = _a.top, width = _a.width;
        var x = left - relativeRect.left;
        var y = top - relativeRect.top;
        return {
            x: x,
            y: y,
            width: width,
            height: height,
            left: left,
            top: top,
        };
    }
    return { x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 };
};
export default measureLayout;
